import { createTheme } from '@mui/material/styles';

const darkBackground = '#003047';
const brandYellow = '#e6ac30';

const theme = createTheme({
  palette: {
    primary: { main: brandYellow },
    secondary: { main: '#57B3FF' },
    background: { default: darkBackground, paper: '#FFFFFF' },
    text: { primary: '#0A1F24', secondary: '#5A6A6F' },
  },
  shape: { borderRadius: 12 },
  typography: {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
    h2: { fontWeight: 800, fontSize: '3rem', lineHeight: 1.05 },
    h5: { fontWeight: 700 },
    body1: { fontSize: '1rem', lineHeight: 1.6 },
    button: { fontWeight: 600 },
  },
  components: {
    MuiButton: { styleOverrides: { root: { textTransform: 'none', borderRadius: 10, paddingInline: 20, paddingBlock: 10 } } },
    MuiTextField: { defaultProps: { size: 'medium' } },
    MuiOutlinedInput: { styleOverrides: { root: { backgroundColor: '#fff' }, input: { color: '#000' } } },
    MuiInputBase: { styleOverrides: { input: { color: '#000', '::placeholder': { color: '#5A6A6F', opacity: 1 } } } },
    MuiPaper: { styleOverrides: { root: { borderRadius: 16 } } },
    MuiDivider: { styleOverrides: { root: { opacity: 0.6 } } },
  },
});

export default theme;
